var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPorteria(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Porteria",
    xmlns: "http://www.w3.org/2000/svg",
    width: 198.759,
    height: 198.759,
    viewBox: "0 0 198.759 198.759",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #24303c;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    className: "cls-1",
    d: "M218.191,349.033a4.758,4.758,0,1,0,3.36-1.393A4.758,4.758,0,0,0,218.191,349.033Z",
    transform: "translate(-131.405 -210.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    className: "cls-1",
    d: "M442.241,393.55a4.762,4.762,0,1,0,3.36,1.4A4.763,4.763,0,0,0,442.241,393.55Z",
    transform: "translate(-269.159 -238.54)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    className: "cls-1",
    d: "M194.876,103.263H177.782V70.695a19.478,19.478,0,0,0-15.2-18.91L149.9,49a20.317,20.317,0,0,0,7.124-15.452V20.365a20.365,20.365,0,1,0-40.73,0v13.19a20.314,20.314,0,0,0,7.113,15.44l-12.69,2.782A19.478,19.478,0,0,0,95.5,70.687V87.732H74.535a3.888,3.888,0,0,0-3.884,3.884v11.647H43.481V92.391h16.3a3.884,3.884,0,0,0,3.884-3.88V46.585A3.884,3.884,0,0,0,59.779,42.7H3.884A3.88,3.88,0,0,0,0,46.585V88.512a3.88,3.88,0,0,0,3.884,3.88h16.3v10.872H3.884A3.88,3.88,0,0,0,0,107.143v18.636a3.88,3.88,0,0,0,3.884,3.88h13.21v65.217a3.88,3.88,0,0,0,3.868,3.884H177.8a3.88,3.88,0,0,0,3.88-3.884V175.854a3.884,3.884,0,0,0-7.764,0V191H24.845V145.957h49.69a3.884,3.884,0,1,0,0-7.764H24.845v-8.535h149.07V144.8a3.884,3.884,0,0,0,7.764,0V129.659h13.2a3.88,3.88,0,0,0,3.884-3.88V107.143a3.88,3.88,0,0,0-3.884-3.88ZM124.046,30.8h5.343a35.709,35.709,0,0,0,19.876-5.963v8.714a12.6,12.6,0,1,1-25.2,0Zm12.6,23.116a20.376,20.376,0,0,0,3.542-.314l-3.578,8.086-3.6-8.105A20.417,20.417,0,0,0,136.647,53.919Zm0-46.156a12.621,12.621,0,0,1,11.707,7.95,28,28,0,0,1-18.966,7.342h-5.343V20.365A12.617,12.617,0,0,1,136.647,7.764ZM103.256,70.687a11.659,11.659,0,0,1,9.107-11.325l13.4-2.938,7.286,16.406a3.884,3.884,0,0,0,7.1,0l7.286-16.41,13.48,2.95a11.655,11.655,0,0,1,9.115,11.325v32.569H128.108V91.616a3.888,3.888,0,0,0-3.884-3.884H103.263ZM78.411,95.5h41.93v7.768H78.419ZM7.764,50.485H55.9V84.648H43.417a11.647,11.647,0,0,0-23.171,0H7.764ZM27.95,85.864a3.884,3.884,0,1,1,7.764,0V103.3H27.95ZM191,121.935H7.764V111.027H191Z",
    transform: "translate(0)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPorteria);
export default __webpack_public_path__ + "static/media/Porteria.648809c4b4f98847df2b286b1384bd53.svg";
export { ForwardRef as ReactComponent };